import { render, staticRenderFns } from "./Piso.vue?vue&type=template&id=6bfca232"
import script from "./Piso.vue?vue&type=script&lang=js"
export * from "./Piso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports